import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-parent-empty-state',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './parent-empty-state.component.html',
  styleUrl: './parent-empty-state.component.scss',
  host: {
    '[class.parent-empty-state-host--centered]': 'centered()',
  },
})
export class ParentEmptyStateComponent {
  titleKey = input.required<string>();
  subtitleKey = input<string | null>(null);
  ariaLabelKey = input<string | null>(null);
  iconMask = input<string | null>(null);
  centered = input(true);

  readonly iconMaskStyle = computed(() => {
    const mask = this.iconMask();
    return mask ? `url('${mask}')` : null;
  });
}
